import { Mesh, AnimationGroup, Scene, PointerEventTypes } from "@babylonjs/core";

export default class PlayFloatingAnimation {
    public _scene: Scene;
    public _attachedMeshName: string;
    public _animationGroupFloating: AnimationGroup | null = null;
    public _animationGroupSpinFloating: AnimationGroup | null = null;
    public _attachedMesh: Mesh | null = null;
    public _defaultAnimationFrame: number = 0; // デフォルトアニメーションの停止フレームを記録

    constructor(attachedMeshName: string) {
        this._attachedMeshName = attachedMeshName;
    }


    public onInitialize(): void {

        // アニメーショングループを取得
        this._animationGroupFloating = this._scene.getAnimationGroupByName("fy-floating2"); // 例: "Idle"
        if (!this._animationGroupFloating) {
            console.error("Floatingのアニメーショングループが見つかりません。");
        }

        this._animationGroupSpinFloating = this._scene.getAnimationGroupByName("fy-spin-floating"); // 例: "Idle"
        if (!this._animationGroupSpinFloating) {
            console.error("SpinFloatingのアニメーショングループが見つかりません。");
        }

        const attachedMesh = this._scene.getMeshByName(this._attachedMeshName);
        if (attachedMesh) {
            attachedMesh.isPickable = true; // ピック可能に設定
        } else {
            console.error("対象メッシュが見つかりません。");
        }

        this._scene.onPointerObservable.add((pointerInfo) => {
            if (pointerInfo.type === PointerEventTypes.POINTERDOWN) {
                console.log("マウスをクリック");
                this.playSpinFloatingAnimation(); // アニメーション再生
                const pickInfo = pointerInfo.pickInfo;
                if (pickInfo.pickedMesh?.name === this._attachedMeshName) {
                    console.log("ファイさんをタップ");
                    this.playSpinFloatingAnimation(); // アニメーション再生
                }
            }
        });
    }

    public onStart(): void {
        // アニメーションを再生
        if (this._animationGroupFloating) {
            this._animationGroupFloating.start(true); // trueでループ再生
        }
    }

    public playSpinFloatingAnimation(): void {
        if (!this._animationGroupFloating || !this._animationGroupSpinFloating) {
            return;
        }

        // 元のアニメーショングループを停止
        this._animationGroupFloating.pause();
        this._defaultAnimationFrame = this._animationGroupFloating.animatables[0]?.masterFrame ?? 0;
        console.log(this._defaultAnimationFrame);

        // タップ時のアニメーションを再生
        this._animationGroupSpinFloating.start(false); // 一度だけ再生

        // アニメーション終了時に元のアニメーションに戻す
        this._animationGroupSpinFloating.onAnimationGroupEndObservable.addOnce(() => {
            if (this._animationGroupFloating) {
                this._animationGroupFloating.goToFrame(this._defaultAnimationFrame);
                this._animationGroupFloating.play(true); // 元のアニメーションを再生
            }
        });
    }

    public onStop(): void {
        // アニメーションを停止
        if (this._animationGroupFloating) {
            this._animationGroupFloating.stop();
        }
    }
}